"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatePasswordResponseResult = exports.ValidateMyPasswordResponseResult = exports.Name = exports.Result = exports.PolicyType = void 0;
var PolicyType;
(function (PolicyType) {
    /** Unknown Type */
    PolicyType["UNKNOWN_POLICY_TYPE"] = "UNKNOWN_POLICY_TYPE";
    /** Default Password Policy */
    PolicyType["DEFAULT"] = "DEFAULT";
    /** Custom Password policy */
    PolicyType["CUSTOM"] = "CUSTOM";
})(PolicyType = exports.PolicyType || (exports.PolicyType = {}));
/** Result */
var Result;
(function (Result) {
    /** Unknown Result */
    Result["UNKNOWN_RESULT"] = "UNKNOWN_RESULT";
    /** All good, password policy can be updated */
    Result["SUCCESS"] = "SUCCESS";
    /** Password policy can be updated only with current password */
    Result["CURRENT_PASSWORD_REQUIRED"] = "CURRENT_PASSWORD_REQUIRED";
})(Result = exports.Result || (exports.Result = {}));
/** Rule name */
var Name;
(function (Name) {
    /** Unknown Name */
    Name["UNKNOWN_NAME"] = "UNKNOWN_NAME";
    /** min_length rule violated */
    Name["STRENGTH_MIN_LENGTH"] = "STRENGTH_MIN_LENGTH";
    /** min_symbol rule violated */
    Name["STRENGTH_MIN_SYMBOL"] = "STRENGTH_MIN_SYMBOL";
    /** min_lower_case violated */
    Name["STRENGTH_MIN_LOWER_CASE"] = "STRENGTH_MIN_LOWER_CASE";
    /** min_upper_case rule violated */
    Name["STRENGTH_MIN_UPPER_CASE"] = "STRENGTH_MIN_UPPER_CASE";
    /** min_number rule violated */
    Name["STRENGTH_MIN_NUMBER"] = "STRENGTH_MIN_NUMBER";
    /** allowed_repetitive_chars_length rule violated */
    Name["STRENGTH_ALLOWED_REPETITIVE_CHARS_LENGTH"] = "STRENGTH_ALLOWED_REPETITIVE_CHARS_LENGTH";
    /** allowed_sequential_chars_length rule violated */
    Name["STRENGTH_ALLOWED_SEQUENTIAL_CHARS_LENGTH"] = "STRENGTH_ALLOWED_SEQUENTIAL_CHARS_LENGTH";
    /** restrict_illegal_chars rule violated */
    Name["STRENGTH_RESTRICT_ILLEGAL_CHARS"] = "STRENGTH_RESTRICT_ILLEGAL_CHARS";
    /** restrict_trailing_whitespaces rule violated */
    Name["STRENGTH_RESTRICT_TRAILING_WHITESPACES"] = "STRENGTH_RESTRICT_TRAILING_WHITESPACES";
    /** restrict_common_passwords rule violated */
    Name["STRENGTH_RESTRICT_COMMON_PASSWORDS"] = "STRENGTH_RESTRICT_COMMON_PASSWORDS";
})(Name = exports.Name || (exports.Name = {}));
/** Result */
var ValidateMyPasswordResponseResult;
(function (ValidateMyPasswordResponseResult) {
    /** Unknown Result */
    ValidateMyPasswordResponseResult["UNKNOWN_RESULT"] = "UNKNOWN_RESULT";
    /** All good, Password is strong */
    ValidateMyPasswordResponseResult["SUCCESS"] = "SUCCESS";
    /** Password is not strong enough */
    ValidateMyPasswordResponseResult["PASSWORD_DOES_NOT_SATISFY_POLICY"] = "PASSWORD_DOES_NOT_SATISFY_POLICY";
})(ValidateMyPasswordResponseResult = exports.ValidateMyPasswordResponseResult || (exports.ValidateMyPasswordResponseResult = {}));
/** Result */
var ValidatePasswordResponseResult;
(function (ValidatePasswordResponseResult) {
    /** Unknown Result */
    ValidatePasswordResponseResult["UNKNOWN_RESULT"] = "UNKNOWN_RESULT";
    /** All good, Password is strong */
    ValidatePasswordResponseResult["SUCCESS"] = "SUCCESS";
    /** Password is not strong enough */
    ValidatePasswordResponseResult["PASSWORD_DOES_NOT_SATISFY_POLICY"] = "PASSWORD_DOES_NOT_SATISFY_POLICY";
})(ValidatePasswordResponseResult = exports.ValidatePasswordResponseResult || (exports.ValidatePasswordResponseResult = {}));
//# sourceMappingURL=types.impl.js.map